import React from 'react';

export default function CreditViewSwitch({ view, setView, kind }) {
    return (
        <div className="flex gap-2 mb-5" data-testid={`credit-view-switch-${kind}`}>
            {[['lista', 'Lista kredytów'], ['nadplata', 'Nadpłata']].map(([k, l]) => (
                <button
                    key={k}
                    onClick={() => setView(k)}
                    className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${view === k ? 'bg-violet-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`}
                    data-testid={`credit-view-${kind}-${k}`}
                >
                    {l}
                </button>
            ))}
        </div>
    );
}
